/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { Ring } from "@uiball/loaders";
import styled from "styled-components";
import ChatWarningModal from "../../../../shared/components/ChatWarningModal/ChatWarningModal";
import { useChainContext } from "../../../context/context";
import ChatGlobalStyle from "./ChatGlobalStyles";
import ChatSidebar from "./ChatSidebar";
import ChatPane from "./ChatPane";
import { useChatSocket } from "./hooks/useChatSocket";
import { useChatData } from "./hooks/useChatData";
import { formatName, getInitials, formatTime, nowHM } from "./utils/chatUtils";

const Chat = () => {
  const { socket, setReConnectSocket, reConnectSocket } = useChainContext();
  console.log("🚀 ~ Chat ~ socket:", socket)
  const history = useHistory();
  const location = useLocation();
  const scrollbarRef = useRef(null);
  const hasStartedChatRef = useRef(false);

  const userdata = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  console.log("🚀 ~ Chat ~ userdata:", userdata)
  const queryParams = new URLSearchParams(window.location.search);
  const otcNameParam = queryParams.get("otcName");
  const projectParam = queryParams.get("project");
  const userId = queryParams.get("userId");


  // Reset ref when userId changes
  useEffect(() => {
    hasStartedChatRef.current = false;
  }, [userId]);

  const [currentChat1, setCurrentChat1] = useState(null);
  const [ChatId, setChatId] = useState();
  const [searchTotaluser, setSearchTotaluser] = useState(1);
  const [currentView, setCurrentView] = useState(otcNameParam ? "room" : "chats");
  const [q, setQ] = useState("");
  const [sel, setSel] = useState("");
  const [pinned, setPinned] = useState(new Set());
  const [archived, setArchived] = useState(new Set());
  const [selected, setSelected] = useState(new Set());
  const [msgQ, setMsgQ] = useState("");
  const [filter, setFilter] = useState("all");
  const [showChatOnMobile, setShowChatOnMobile] = useState(false);
  const [isOpeningChat, setIsOpeningChat] = useState(false);

  const {
    chatData,
    roomData,
    ChatMessage,
    selectedChat,
    getBlock,
    getBlock1,
    show,
    readStatus,
    setChatData,
    setroomData,
    setChatMessage,
    getChatData,
    fetchChats,
  } = useChatData(userdata, otcNameParam, projectParam);


  const handleNewMessage = () => {
    getChatData();
  };
  const handleNewChat = (response) => {
    if (Array.isArray(response)) {
      response.forEach((newObj) => {
        if (newObj.type === "room") {
          setroomData((prevroomData) => {
            if (!prevroomData.some((roomObj) => roomObj._id === newObj._id)) {
              return [...prevroomData, newObj];
            }
            return prevroomData;
          });
        } else if (newObj.type === "chat") {
          setChatData((prevChatData) => {
            if (!prevChatData.some((chatObj) => chatObj._id === newObj._id)) {
              return [...prevChatData, newObj];
            }
            return prevChatData;
          });
        }
      });
    }
  };

  const { messagesArray, flag, setMessagesArray } = useChatSocket(
    socket,
    ChatId,
    userdata,
    handleNewMessage,
    null,
    handleNewChat
  );

  useEffect(() => {
    if (otcNameParam) {
      setCurrentView("room");
    }
    if (projectParam) {
      setCurrentView("chats");
    }
  }, [otcNameParam, projectParam]);

  // Auto-open chat when userId is provided in query params
  useEffect(() => {
    if (!userId || !socket || hasStartedChatRef.current || sel) {
      setIsOpeningChat(false);
      return;
    }

    setIsOpeningChat(true);

    // Wait for socket to connect, then start chat process
    const startChatProcess = () => {
      if (!socket.connected) {
        return () => { };
      }

      // Quick check for existing chat if chatData is already loaded
      const checkAndStartChat = () => {
        if (chatData && chatData.length > 0) {
          const foundChat = chatData.find((chat) => {
            const userDetailId = chat.user_detail?.[0]?._id;
            return userDetailId && String(userDetailId) === String(userId);
          });

          if (foundChat) {
            hasStartedChatRef.current = true;
            if (foundChat?.chat_status?.length > 0) {
              setCurrentChat1(foundChat);
              setChatId(foundChat?.chat_status[0]?._id);
              fetchChats(foundChat?.chat_status[0]?._id);
              setSel(foundChat?.chat_status[0]?._id);
              setMessagesArray([]);
              if (window.innerWidth <= 960) {
                setShowChatOnMobile(true);
              }
            } else {
              setCurrentChat1(foundChat);
              setChatId(foundChat?._id);
              fetchChats(foundChat?._id);
              setSel(foundChat?._id);
              setMessagesArray([]);
              if (window.innerWidth <= 960) {
                setShowChatOnMobile(true);
              }
            }
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete("userId");
            window.history.replaceState({}, "", newUrl);
            setIsOpeningChat(false);
            return true;
          }
        }
        return false;
      };

      // Quick check for existing chat (don't wait if not loaded)
      if (checkAndStartChat()) {
        return () => { };
      }

      // Start new chat immediately - don't wait for chatData
      hasStartedChatRef.current = true;

      // Create handler function that processes the chat response
      const processChatResponse = (response) => {
        if (!response || !response._id) {
          return;
        }

        hasStartedChatRef.current = true;
        setCurrentChat1(response);
        setChatId(response._id);
        setChatData((prev) => {
          const exists = prev.some((chat) => chat._id === response._id);
          return exists ? prev : [...prev, response];
        });
        fetchChats(response._id);
        setSel(response._id);
        setMessagesArray([]);
        if (window.innerWidth <= 960) {
          setShowChatOnMobile(true);
        }
        // Remove userId from URL to prevent re-triggering
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("userId");
        window.history.replaceState({}, "", newUrl);
        setIsOpeningChat(false);
      };

      const handleGetChatId = (response) => {
        processChatResponse(response);
      };

      const handleNewChat = (response) => {
        // new_chat might be an array or single object
        const chatResponse = Array.isArray(response) ? response.find(c => c.type === "chat") : response;
        if (chatResponse && chatResponse._id) {
          processChatResponse(chatResponse);
        }
      };

      // Set up listeners BEFORE emitting to ensure they're ready
      socket.on("get_chat_id", handleGetChatId);
      socket.on("new_chat", handleNewChat);

      // Start chat immediately - don't wait for chatData
      socket.emit(
        "startChat",
        {
          subject: "Start New One to One Chat",
          user_id: userdata,
          user_id_2: userId,
          type: "user",
        },
        (response) => {
          // Sometimes the response comes in the callback instead of get_chat_id event
          if (response && response._id) {
            processChatResponse(response);
          }
        }
      );

      // Add a timeout to check if we got a response (reduced from 5s)
      const responseTimeout = setTimeout(() => {
        // Timeout handler - no action needed
      }, 3000);

      return () => {
        clearTimeout(responseTimeout);
      };
    };

    // Wait for socket connection if not connected
    if (!socket.connected) {
      let connectHandlerAttached = false;
      let intervalId = null;
      let timeoutId = null;
      let hasStarted = false;

      const startProcess = () => {
        if (hasStarted) return;
        hasStarted = true;
        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
        startChatProcess();
      };

      const handleConnect = () => {
        startProcess();
      };

      const handleConnectError = () => {
        // Error handler - no action needed
      };

      // Set up listeners
      socket.on("connect", handleConnect);
      socket.on("connect_error", handleConnectError);
      connectHandlerAttached = true;

      // Check if socket connected between check and listener setup (race condition)
      if (socket.connected) {
        startProcess();
        return () => {
          if (intervalId) clearInterval(intervalId);
          if (timeoutId) clearTimeout(timeoutId);
        };
      }

      // Also try to connect if not already connecting
      if (!socket.connecting && socket.disconnected) {
        socket.connect();
      }

      // Poll for connection status (handles cases where event doesn't fire)
      intervalId = setInterval(() => {
        if (socket.connected && !hasStarted) {
          startProcess();
        }
      }, 100); // Check every 100ms for faster response

      // Timeout after 10 seconds
      timeoutId = setTimeout(() => {
        if (!hasStarted && intervalId) {
          clearInterval(intervalId);
        }
      }, 10000);

      return () => {
        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    } else {
      return startChatProcess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, chatData, sel, socket]);

  useEffect(() => {
    if (!socket) return;

    const handleSearchResponse = (response) => {
      setSearchTotaluser((prev) => {
        if (prev !== 0) {
          setChatData(response);
        }
        return prev;
      });
    };

    socket.on("searchUser_response", handleSearchResponse);

    return () => {
      socket.off("searchUser_response", handleSearchResponse);
    };
  }, [socket, setChatData]);

  const baseUrl = window.location.origin;

  let adminId = "694057237a9c10d7e80a538b";
  // if (baseUrl === "http://localhost:3000" || baseUrl === "https://pharma-dev.custodiy.com") {
  //   adminId = "694057237a9c10d7e80a538b";
  // } else {
  //   adminId = "694057237a9c10d7e80a538b";
  // }
  // adminId = "694057237a9c10d7e80a538b";

  const sendMessage = (message) => {
    if (!message || !message.trim() || !socket || !ChatId || !currentChat1) {
      return;
    }

    if (!socket.connected) {
      socket.connect();
    }

    const trimmedMessage = message.trim();

    const user = JSON.parse(localStorage.getItem("user"))?.data?.user;
    const tempMessage = {
      message: trimmedMessage,
      sender_id: userdata,
      chat_id: ChatId,
      type: "user",
      user: user ? { name: `${user.firstName} ${user.lastName}` } : null,
      _id: `temp_${Date.now()}`,
      createdAt: new Date().toISOString(),
    };
    setMessagesArray((prevMessages) => [...prevMessages, tempMessage]);

    if (currentChat1?.type === "room") {
      socket.emit(
        "sendGroupMessage",
        {
          room_id: ChatId,
          sender_id: userdata,
          message: trimmedMessage,
        },
        () => { }
      );
    } else {
      socket.emit(
        "sendMessage",
        {
          chat_id: ChatId,
          sender_id: userdata,
          message: trimmedMessage,
        },
        () => { }
      );
    }
  };

  const onOpenChat = (item) => {
    if (!otcNameParam && !projectParam) {
      history.push("/livechat");
    }

    if (item?.chat_status?.length === 0) {
      socket.emit(
        "startChat",
        {
          subject: "Start New One to One Chat",
          user_id: userdata,
          user_id_2: item._id,
          type: "user",
        },
        (response) => { }
      );
      socket.on("get_chat_id", (response) => {
        if (response) {
          setCurrentChat1(response);
          setChatId(response._id);
          setChatData([response]);
          fetchChats(response._id);
          setSel(response._id);
          setMessagesArray([]);
          if (window.innerWidth <= 960) {
            setShowChatOnMobile(true);
          }
        }
      });
    } else {
      if (item?.chat_status?.length > 0) {
        setCurrentChat1(item);
        setChatId(item?.chat_status[0]?._id);
        fetchChats(item?.chat_status[0]?._id);
        setSel(item?.chat_status[0]?._id);
        setMessagesArray([]);
        if (window.innerWidth <= 960) {
          setShowChatOnMobile(true);
        }
      } else {
        setCurrentChat1(item);
        setChatId(item?._id);
        fetchChats(item?._id);
        setSel(item?._id);
        setMessagesArray([]);
        if (window.innerWidth <= 960) {
          setShowChatOnMobile(true);
        }
      }
    }
  };

  const StartNewChat = () => {
    socket.emit(
      "startChat",
      {
        subject: "Start New Chat with Support",
        user_id: userdata,
        user_id_2: adminId,
        type: "private",
      },
      (response) => { }
    );
    socket.on("get_chat_id", (response) => {
      if (response) {
        setCurrentChat1(response);
        setChatId(response._id);
        fetchChats(response._id);
        setChatData([response]);
        setSel(response._id);
        setMessagesArray([]);
        if (window.innerWidth <= 960) {
          setShowChatOnMobile(true);
        }
      }
    });
  };

  const searchUsersSoket = (value) => {
    if (!socket) return;
    socket.emit(
      "searchUsers",
      {
        name: value,
        user_id: userdata,
      },
      (response) => { }
    );
  };

  const handleSearchChange = (value) => {
    if (value.length === 0) {
      setSearchTotaluser(0);
      setChatData([]);
      getChatData();
    }
    if (currentView === "chats") {
      if (value.length !== 0) {
        searchUsersSoket(value);
      }
    }
    setQ(value);
  };

  useEffect(() => {
    if (scrollbarRef.current) {
      const element = scrollbarRef.current;
      if (element.scrollTo) {
        element.scrollTo(0, element.scrollHeight);
      } else {
        element.scrollTop = element.scrollHeight;
      }
    }
  }, [ChatMessage, messagesArray]);

  const displayData = currentView === "chats" ? chatData : roomData;

  const allThreads = [
    ...(currentView === "chats"
      ? [
        {
          id: "new",
          name: "Start new chat with Support",
          initials: "+ ",
          unread: 0,
          last: "—",
          tag: "NEW",
          system: true,
          online: true,
          _id: "new",
        },
      ]
      : []),
    ...displayData.map((item) => {
      let image = null;
      if (item.type === 'room' && item?.support_user_id === '64d200a15a0ec71ba4278c9f' && item.approver_user_id?.length > 0) {
        image = `${process.env.PUBLIC_URL}/img/avatgroup.png`;
      } else if (item.type === 'otc-room') {
        image = `${process.env.PUBLIC_URL}/img/avatgroup.png`;
      } else {
        image = item.user_detail?.[0]?.image || item.image || null;
      }

      return {
        id: item._id,
        name: item.user_detail?.[0]?.name || item.name || item.subject || "Unknown",
        initials: getInitials(item.user_detail?.[0]?.name || item.name || item.subject || "Unknown"),
        image: image,
        unread: 0,
        last: item.last_message || "—",
        date: formatTime(item.updatedAt),
        online: item.online_status?.[0]?.online_status === true,
        _id: item._id,
        ...item,
      };
    }),
  ];

  const filtered = allThreads.filter((t) => formatName(t.name).toLowerCase().includes(q.toLowerCase()));

  const filteredByType = filtered.filter((t) => {
    if (filter === "active") return t.online === true;
    if (filter === "pinned") return true;
    if (filter === "archived") return true;
    return true;
  });

  const sorted = [...filteredByType].sort((a, b) => (pinned.has(b.id) ? 1 : 0) - (pinned.has(a.id) ? 1 : 0));

  const allMessages = [
    ...ChatMessage.map((msg) => {
      const senderId = msg.user_id || msg.sender_id || msg.user?._id || msg.user_detail?.[0]?._id || msg.user_detail?.[0]?.user_id;
      const isFromMe = senderId && userdata ? String(senderId) === String(userdata) : false;

      return {
        from: isFromMe ? "me" : "them",
        text: msg.message || "",
        ts: formatTime(msg.createdAt) || nowHM(),
        files: msg.Files || msg.file || [],
        status: isFromMe ? (readStatus?.find((r) => r._id === ChatId)?.status === "read" ? "read" : "delivered") : undefined,
        _id: msg._id,
        user: msg.user || msg.user_detail?.[0],
        type: msg.type,
        chat_id: msg.chat_id,
        room_id: msg.room_id,
      };
    }),
    ...messagesArray
      .map((msg) => {
        const senderId = msg.user?._id || msg.sender_id || msg.user_id;
        const isFromMe = senderId && userdata ? String(senderId) === String(userdata) : false;

        return {
          from: isFromMe ? "me" : "them",
          text: msg.message || "",
          ts: msg.createdAt ? formatTime(msg.createdAt) : (msg.ts || nowHM()),
          files: msg.Files || msg.files || [],
          status: isFromMe ? "sent" : undefined,
          _id: msg._id || msg.message_id || Date.now(),
          user: msg.user,
          type: msg.type,
        };
      }),
  ];

  const msgs = allMessages.filter((m) => m.text.toLowerCase().includes(msgQ.toLowerCase()));

  const togglePin = (id) => {
    const n = new Set(pinned);
    n.has(id) ? n.delete(id) : n.add(id);
    setPinned(n);
  };

  const doArchive = (id) => {
    const n = new Set(archived);
    n.add(id);
    setArchived(n);
    if (sel === id) setSel("");
    const m = new Set(selected);
    m.delete(id);
    setSelected(m);
  };

  const handleThreadSelect = (thread) => {
    if (thread.id === "new") {
      StartNewChat();
    } else {
      onOpenChat(thread);
      if (window.innerWidth <= 960) {
        setShowChatOnMobile(true);
      }
    }
  };

  const selectedThread = allThreads.find((t) => t.id === sel);
  const typing = flag ? "typing…" : selectedThread?.online ? "Online" : "Offline";

  return (
    <div className="chat-wrap">
      <ChatGlobalStyle />
      {isOpeningChat && (
        <LoaderOverlay>
          <Ring size={60} color="#00f7d2" />
          <LoaderText>Opening chat...</LoaderText>
        </LoaderOverlay>
      )}
      <div className="max">
        {show && <ChatWarningModal open={show} />}

        <div className="grid">
          <ChatSidebar
            currentView={currentView}
            onViewChange={setCurrentView}
            searchQuery={q}
            onSearchChange={handleSearchChange}
            filter={filter}
            onFilterChange={setFilter}
            threads={sorted}
            selectedThreadId={sel}
            pinned={pinned}
            onThreadSelect={handleThreadSelect}
            onPin={togglePin}
            onArchive={doArchive}
            showChatOnMobile={showChatOnMobile}
          />

          <ChatPane
            selectedThread={selectedThread}
            messages={msgs}
            onBack={() => {
              setShowChatOnMobile(false);
              setSel("");
            }}
            showBackButton={!!sel}
            onSendMessage={sendMessage}
            chatId={ChatId}
            isBlocked={getBlock}
            isBlockedBy={getBlock1}
            scrollbarRef={scrollbarRef}
          />
        </div>
      </div>
    </div>
  );
};

Chat.propTypes = {};

export default Chat;

// Styled components for loader
const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(11, 14, 20, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  gap: 20px;
`;

const LoaderText = styled.div`
  color: #00f7d2;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
`;
